const cmpIframe = {

  init: function (element) {
    console.log('init iframe')
  }
}

export default cmpIframe
